<script>
import SeoMixin from '~/sites/cvb/mixins/SeoMixin'

export default {
  extends: SeoMixin,
  methods: {
    getSeoMetaAttrsCustom(data) {
      return {
        script: [],
      }
    },
  },
}
</script>
